import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock, FileQuestion } from "lucide-react";
import { api } from "../lib/api";

export default function Tools() {
  const [tools, setTools] = useState([]);
  useEffect(() => { api.get("/tools").then(r => setTools(r.data.tools)); }, []);

  return (
    <div data-testid="page-tools">
      <section className="border-b border-slate-200">
        <div className="container-rp py-16 lg:py-24">
          <div className="overline">Interactive Tools</div>
          <h1 className="font-display text-5xl lg:text-6xl font-bold mt-3 tracking-tight">Stop guessing.<br />Score yourself.</h1>
          <p className="text-slate-600 mt-4 text-lg max-w-2xl">Practitioner tools — free, no login, instant results. Built on Singapore obligations.</p>
        </div>
      </section>

      <section className="section">
        <div className="container-rp">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200">
            {tools.map(t => (
              <Link to={`/tools/${t.slug}`} key={t.slug} className="bg-white p-6 hover:bg-slate-50 transition-colors flex flex-col" data-testid={`tool-card-${t.slug}`}>
                <div className="overline-muted flex items-center gap-3"><Clock size={11} /> {t.duration} · <FileQuestion size={11} /> {t.questions} q</div>
                <div className="font-display text-xl font-semibold mt-4">{t.name}</div>
                <p className="text-sm text-slate-600 mt-2 leading-relaxed flex-1">{t.description}</p>
                <div className="mt-5 flex items-center justify-between border-t border-slate-100 pt-4 text-xs">
                  <span className="text-slate-500 line-clamp-1">{t.outcome}</span>
                  <span style={{ color: "var(--rp-accent)" }} className="font-medium inline-flex items-center gap-1">Open <ArrowRight size={12} /></span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
